import { render, staticRenderFns } from "./CmgModal.vue?vue&type=template&id=844156d4&scoped=true&lang=pug&"
import script from "./cmg-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgModal.vue?vue&type=style&index=0&id=844156d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844156d4",
  null
  
)

export default component.exports